import { render, staticRenderFns } from "./MultipleInput.vue?vue&type=template&id=45b2eadd"
import script from "./MultipleInput.vue?vue&type=script&lang=ts"
export * from "./MultipleInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports